export const GlowlabsPromos = ['loyal5', 'loyal15', 'loyal25', 'loyalpouch'];
